module.exports = __webpack_public_path__ + "img/icon-filtrar.2c9fd57b.svg";